import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_TENANT_CONSTANTS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: TenantConstantPageFilter
	) {
		getTenantConstants(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
			}
			count
		}
	}
`;


const TenantConstantSelector = (props) => {

	const { query, constantType } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_TENANT_CONSTANTS}
			initialFilter={{
				type: constantType,
			}}
			renderItem={item => <Text>{ item.name }</Text>}
			// A value without a name (e.g. not in the query) would leave the field blank.
			renderLabel={item => <Text>{ item.name || 'None selected' }</Text>}
			placeholder="None selected"
			{...props}
		/>
	);
};

export default TenantConstantSelector;
